// Pure JavaScript disposable and spam-testing email detector (Zero Node.js dependencies for Webpack 5)

const SPAM_KEYWORDS = [
  'spam-tester',
  'tempmail',
  'temp-mail',
  'trashmail',
  'mailinator',
  'guerrillamail',
  '10minutemail',
  'yopmail',
  'fakeinbox',
  'throwaway',
  'disposable',
  'burnermail',
  'emailondeck',
  'sharklasers',
  'getairmail',
  'dispostable',
  'mytempemail',
  'dropmail',
  'crazymailing',
  'mohmal',
  'nada.ltd',
  'getnada',
  'inboxkitten',
  'generator.email',
  'tempail'
];

const DISPOSABLE_DOMAINS = new Set([
  'mailinator.com',
  'mailinator.net',
  'mailin8r.com',
  'guerrillamail.com',
  'guerrillamailblock.com',
  'guerrillamail.net',
  'guerrillamail.org',
  'guerrillamail.biz',
  'grr.la',
  'sharklasers.com',
  '10minutemail.com',
  '10minutemail.net',
  '10minmail.com',
  'temp-mail.org',
  'tempmail.com',
  'tempmail.net',
  'tempmailaddress.com',
  'trashmail.com',
  'trashmail.net',
  'trashmail.me',
  'yopmail.com',
  'yopmail.fr',
  'yopmail.net',
  'cool.fr.nf',
  'jetable.fr.nf',
  'courriel.fr.nf',
  'moncourrier.fr.nf',
  'monemail.fr.nf',
  'monmail.fr.nf',
  'fakeinbox.com',
  'fakemailgenerator.com',
  'throwawaymail.com',
  'burnermail.io',
  'emailondeck.com',
  'getairmail.com',
  'dispostable.com',
  'mytempemail.com',
  'dropmail.me',
  'crazymailing.com',
  'mohmal.com',
  'nada.ltd',
  'getnada.com',
  'inboxkitten.com',
  'email-spam-tester.com',
  'maildrop.cc',
  'inboxbear.com',
  'inboxalias.com',
  'tempr.email',
  'discard.email',
  'discardmail.com',
  'spambog.com',
  'spamgourmet.com',
  'harakirimail.com',
  'mytemp.email',
  'emailfake.com',
  'generator.email',
  'luxusmail.org',
  'generator-email.com',
  'temp-mail.io',
  'tempail.com',
  'trash-mail.com',
  'mytempmail.com',
  'fakemail.net',
  'byom.de'
]);

export const isDisposableEmail = email => {
  if (!email || typeof email !== 'string') return false;
  const domain = email.split('@')[1]?.toLowerCase() || '';
  if (!domain) return false;

  // 1. Direct domain match
  if (DISPOSABLE_DOMAINS.has(domain)) {
    return true;
  }

  // 2. Subdomain check (e.g. t.email-spam-tester.com -> email-spam-tester.com)
  const parts = domain.split('.');
  if (parts.length > 2) {
    const rootDomain = parts.slice(-2).join('.');
    if (DISPOSABLE_DOMAINS.has(rootDomain)) {
      return true;
    }
  }

  // 3. Keyword / Pattern match for dynamically generated spam domains
  return SPAM_KEYWORDS.some(keyword => domain.includes(keyword));
};
